import "./page-indicator.css";
import { PageIndicator } from './page-indicator';
export default PageIndicator;